export default {
  state: {
    validPhoneRegExp: /^(\s*)?(\+)?([- _():=]?\d[- _():=]?){6,15}(\s*)?$/,
    valid: null
  },
  mutations: {
    validationPhone (state, val) {
      state.valid = state.validPhoneRegExp.test(val);
    },
  },
  actions: {
    validationPhone ({commit}, val) {
      commit('validationPhone', val);
    },
  },
  getters: {
    isValid(state) {
      return state.valid
    },
  }
}